import { render, staticRenderFns } from "./phrases.vue?vue&type=template&id=42bb5d8e&scoped=true"
import script from "./phrases.vue?vue&type=script&lang=js"
export * from "./phrases.vue?vue&type=script&lang=js"
import style0 from "./phrases.vue?vue&type=style&index=0&id=42bb5d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bb5d8e",
  null
  
)

export default component.exports